/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Why_Fast_DescInputs */

const en_wc_why_fast_desc = /** @type {(inputs: Wc_Why_Fast_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout is cached per paragraph, so typing in a 188-page document re-lays it out in about 1.4 ms.`)
};

/**
* | output |
* | --- |
* | "Layout is cached per paragraph, so typing in a 188-page document re-lays it out in about 1.4 ms." |
*
* @param {Wc_Why_Fast_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_why_fast_desc = /** @type {((inputs?: Wc_Why_Fast_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Why_Fast_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_why_fast_desc(inputs)
});
export { wc_why_fast_desc as "wc.why.fast.desc" }